'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var device = require('../device.js');
var normalizeLang = require('../normalizeLang.js');
require('../tslib.es6-cd939937.js');
require('ua-parser-js');
require('../languages.js');

function getDeviceInfo(accessData) {
    //    let b = Config.get('deviceInfo.browserName');
    //    let o = Config.get('deviceInfo.osName');
    //    let str = b && o && b !== o ? `${o} + ${b}` : `${b || 'unknown'}`;
    //    return `${Config.get('appInfo.device_key') || 'vimmi.' + this.deviceType}, ${str}, AppVersion: ${Config.get('appInfo.version') || '0.0.0'}, ${Config.get('deviceInfo.osVersion') || 'unknown'}, Language: ${Config.get('appInfo.language') || 'unknown'}`;
    var b = device.device.getBrowserName();
    var o = device.device.getOsName();
    var ov = device.device.getOsVersion();
    var str = b && o && b !== o ? o + " + " + b : "" + (b || 'unknown');
    var lang = accessData.language ? normalizeLang.normalizeLang(accessData.language, "iso-3") : 'unknown';
    return (accessData.device_key || 'vimmi.' + accessData.platform) + ", " + str + ", AppVersion: " + (accessData.version || '0.0.0') + ", " + (ov || 'unknown') + ", Language: " + lang;
}

exports.getDeviceInfo = getDeviceInfo;
